import {
  enUS,
  esAR,
  esCL,
  esCO,
  esES,
  esPE,
  esMX,
  ptBR,
  itIT,
  ptPT,
  deDE,
  frFR,
} from 'src/intl/messages';

const localeProviderMap = new Map<string, { [key: string]: string }>([
  ['en-US', enUS],
  ['es-AR', esAR],
  ['pt-BR', ptBR],
  ['es-CL', esCL],
  ['es-CO', esCO],
  ['de-DE', deDE],
  ['es-ES', esES],
  ['it-IT', itIT],
  ['es-MX', esMX],
  ['es-PE', esPE],
  ['pt-PT', ptPT],
  ['fr-FR', frFR],
]);

export const intlLocaleProvider = (locale: string) => {
  const intlLocale = localeProviderMap.get(locale);
  return intlLocale;
};
